import { usePlatformFeatureFlagEnabled } from '@infinex/user';

type ResolvedFeatureFlag = boolean | undefined;

type CollectFeatureFlags = {
  isCollectEnabled: ResolvedFeatureFlag;
  isCollectMarketplaceEnabled: ResolvedFeatureFlag;
  isCollectiblePositionsEnabled: ResolvedFeatureFlag;
  isGachaOpeningDisabled: ResolvedFeatureFlag;
};

function andWhenResolved(
  master: boolean | undefined,
  subordinate: boolean | undefined
): boolean | undefined {
  if (master === undefined || subordinate === undefined) return undefined;
  return master && subordinate;
}

export function useCollectFeatureFlags(): CollectFeatureFlags {
  const isCollectEnabled = usePlatformFeatureFlagEnabled('enableCollect');
  const isRawCollectMarketplaceEnabled = usePlatformFeatureFlagEnabled(
    'enableCollectMarketplace'
  );
  const isRawCollectiblePositionsEnabled = usePlatformFeatureFlagEnabled(
    'enableCollectiblePositions'
  );
  const isGachaOpeningDisabled = usePlatformFeatureFlagEnabled(
    'disableGachaOpening'
  );

  return {
    isCollectEnabled,
    isCollectMarketplaceEnabled: andWhenResolved(
      isCollectEnabled,
      isRawCollectMarketplaceEnabled
    ),
    isCollectiblePositionsEnabled: andWhenResolved(
      isCollectEnabled,
      isRawCollectiblePositionsEnabled
    ),
    isGachaOpeningDisabled,
  };
}

export function useIsCollectEnabled(): ResolvedFeatureFlag {
  return usePlatformFeatureFlagEnabled('enableCollect');
}

export function useIsCollectMarketplaceEnabled(): ResolvedFeatureFlag {
  const isCollectEnabled = usePlatformFeatureFlagEnabled('enableCollect');
  const isCollectMarketplaceEnabled = usePlatformFeatureFlagEnabled(
    'enableCollectMarketplace'
  );

  return andWhenResolved(isCollectEnabled, isCollectMarketplaceEnabled);
}

export function useIsCollectiblePositionsEnabled(): ResolvedFeatureFlag {
  const isCollectEnabled = usePlatformFeatureFlagEnabled('enableCollect');
  const isCollectiblePositionsEnabled = usePlatformFeatureFlagEnabled(
    'enableCollectiblePositions'
  );

  return andWhenResolved(isCollectEnabled, isCollectiblePositionsEnabled);
}

export function useIsGachaOpeningDisabled(): ResolvedFeatureFlag {
  return usePlatformFeatureFlagEnabled('disableGachaOpening');
}
